import { useRef } from 'react';
import classNames from 'classnames/bind';
import styles from './Account.module.css';
import { Link } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import useBackdrop from '../../../hooks/useBackdrop';
import useModal from '../../../hooks/useModal';

import { apiSlice, useLogoutMutation } from '../../../services/api';
import { persistor } from '../../../services/store';
import { selectUser } from '../../../features/authSlice';

import { IModal } from '../../../types/modal';
import {
  deleteAllTokens,
  getAccessToken,
  setLocalStorage,
} from '../../../utils/storage';
import { VIEW_MY_PROFILE, LOGOUT, HONORIFIC_SUFFIX } from '../../../constants';

export default function Account(props: IModal) {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const { toggleModal } = useModal();

  const user = useAppSelector(selectUser);

  const [logout] = useLogoutMutation();
  const modalRef = useRef<HTMLDivElement>(null);

  const logoutHandler = async () => {
    const accessToken = getAccessToken();
    setLocalStorage('loggedIn', 0);
    try {
      await logout({ accessToken }).unwrap();
      dispatch(apiSlice.util.resetApiState());
      deleteAllTokens();
      await persistor.purge();
    } catch (error) {
      console.log('Fail to Logout', error);
    }
  };

  const closeModal = () =>
    toggleModal({
      id: 'account',
      type: 'account',
      isOpen: false,
    });

  useBackdrop(props, modalRef, { isScroll: true, buttonClass: 'account' });

  return (
    <div className={cx('login_layer', 'notice')} ref={modalRef}>
      <div className={cx('flex')}>
        <span className={cx('user_id', 'text_clip')}>
          {user?.alias} {HONORIFIC_SUFFIX}
        </span>
        <span className={cx('user_email', 'text_clip')}>{user?.email}</span>
        <Link to="/home/settings" className={cx('btn')} onClick={closeModal}>
          <span>{VIEW_MY_PROFILE}</span>
        </Link>
        <Link to="/login" className={cx('btn')} onClick={logoutHandler}>
          <span>{LOGOUT}</span>
        </Link>
      </div>
    </div>
  );
}
